import { render } from "./EtatBoitePage.vue?vue&type=template&id=29b4710a&ts=true"
import script from "./EtatBoitePage.vue?vue&type=script&lang=ts"
export * from "./EtatBoitePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__